export enum FormInputType {
  NotSet = 'NotSet',
  Tel = 'Tel',
  Text = 'Text',
  Number = 'Number',
  Hidden = 'Hidden',
}
